// Alternative Cloudinary upload using backend for signed uploads
import axios from 'axios';

export const uploadImageSecure = async (file: File) => {
  const API_URL = process.env.REACT_APP_API_URL;
  
  if (!API_URL) {
    throw new Error("API URL not configured");
  }

  // Validate file size (max 10MB)
  if (file.size > 10 * 1024 * 1024) {
    throw new Error("File size too large. Maximum size is 10MB.");
  }

  // Validate file type
  if (!file.type.startsWith('image/')) {
    throw new Error("Please select a valid image file.");
  }

  const formData = new FormData();
  formData.append('file', file);

  try {
    console.log("Uploading via backend to:", `${API_URL}/api/upload`);
    const response = await axios.post(`${API_URL}/api/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      },
      timeout: 30000, // 30 second timeout
    });

    console.log("Backend upload response:", response.data);
    return response.data.secure_url || response.data.url;
  } catch (error: any) {
    console.error('Backend upload error:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });
    
    if (error.response?.status === 400) {
      const errorMessage = error.response?.data?.message || "Upload configuration error";
      throw new Error(`Upload failed: ${errorMessage}`);
    }
    
    throw new Error(`Image upload failed: ${error.message}`);
  }
};